import { ContactReciptsDlg } from '../contacts-recipts-dlg.cmp';
import { ContactReportModelDlg } from '../contactReports/contact-report-model-dlg.cmp';
import { ToraxHttp } from '../../utils/custom-http.svc';
import { ContactsData } from '../contacts.data';
import { MatDialog } from '@angular/material/dialog';
import { MatTabGroup } from '@angular/material/tabs';
import { Location } from '@angular/common';
import { Component, OnInit, ViewChild, ChangeDetectorRef, ViewEncapsulation, Input } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Contact, ContactGroup, ContactEvent, ContactReciptsMdl } from './contact';
import { saveAs } from 'file-saver';
import { NavItem } from 'src/app/components/menu-list-item/nav-item';
import { ContactAppointment } from '../contactAppointments/contactAppointment/contactAppointment';
import { ContactMergeContactsDlg } from './contact-merge-contacts-dlg.cmp';
import { ContactVoiceNameDlg } from './contact-voice-name-dlg.cmp';
import { AppConfigService } from 'src/app/services/app-config.service';


@Component({
  selector: 'contact-details',
  templateUrl: './contact-details.tmpl.html',
  styleUrls: ['./contact-edit.scss'],
  encapsulation: ViewEncapsulation.None
})


export class ContactDetails implements OnInit {
  constructor(
    private contactsData: ContactsData,
    private activatedRoute: ActivatedRoute,
    private toraxHttp: ToraxHttp,
    private cdref: ChangeDetectorRef,
    private location: Location,
    public dialog: MatDialog,
    private config: AppConfigService

  ) {
    this.url = this.config.get('apiBaseUrl');
    this.toraxHttp.updatedEvent.subscribe((obj: any) => {
      console.log(obj);
      if (obj.id > 0 && this.contact && obj.id === this.contact.contactID) {
        this.loadContact();
        this.cdref.detectChanges();
      }
    });
  }
  url;
  rerender = false;
  @ViewChild('tabs', { static: true }) tabs: MatTabGroup;
  @ViewChild('childMenu') public childMenu;

  val = false;
  contact: Contact;
  id: number;
  codeIchud: number;
  contactGroups: ContactGroup[]; //
  contactEvents: ContactEvent[]; //
  contactAppointments: ContactAppointment[]; //

  public loadContact(): void {
    if (this.codeIchud) {
      this.contactsData.getByIchud(this.codeIchud)
        .subscribe((c: any) => {
          this.contact = c;
          this.contactGroups = c.contactGroups;
          this.contactEvents = c.contactEvents;
          this.contactAppointments = c.contactAppointments;
          this.id = this.contact.contactID;
          this.codeIchud = this.contact.codeIchud;
          this.location.replaceState(`contacts/${this.id}`);

          this.rerender = true;
          this.cdref.detectChanges();
          this.rerender = false;
        });
    } else {
      this.contactsData.get(this.id)
        .subscribe((c: any) => {
          this.contact = c;
          this.contactGroups = c.contactGroups;
          this.contactEvents = c.contactEvents;
          this.contactAppointments = c.contactAppointments;
          this.id = this.contact.contactID;
          this.codeIchud = this.contact.codeIchud;

          this.rerender = true;
          this.cdref.detectChanges();
          this.rerender = false;
        });
    }

  }

  openVoiceNameDlg() {
    const dialogRef = this.dialog.open(ContactVoiceNameDlg, {
      data: { contactID: this.id, contactName: `${this.contact.firstName} ${this.contact.lastName}` },
      width: '500px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
       this.contactsData.saveVoiceName(result.value).subscribe((result: any) => {
       console.log('Voice name saved', result);
          });
      }
    });
  }

  openMergeContactDlg() {
    const dialogRef = this.dialog.open(ContactMergeContactsDlg, {
      data: { contactID: this.id, contactName: `${this.contact.firstName} ${this.contact.lastName}` }
    });



    dialogRef.beforeClosed().subscribe(result => {
      const alrtResult = prompt('האם אתה בטוח שאתה רוצה למזג?\nכדי לאשר את הפעולה הזן בתיבה את מזהה האיש הנוכחי להעברה/מחיקה\nאחרת לחץ על ביטול');

      console.log('formData-value', result.value);
      console.log('alrtResult', alrtResult);
      console.log('currentOldContactID', result.value.currentOldContactID);
      if (alrtResult != null && alrtResult == result.value.currentOldContactID) {
        if (result && result.value) {
          this.contactsData.mergeContacts(result.value).subscribe((result: any) => {
            dialogRef.close(result);
          });
        }
      }
    });
  }

  showPromptAndHandleResult() {
    const result = prompt('האם אתה בטוח שאתה רוצה למזג?\nכדי לאשר את הפעולה הזן בתיבה את מזהה האיש הנוכחי להעברה/מחיקה\nאחרת לחץ על ביטול');
    if (result == null) {
      console.log('מזהה איש להעברה/מחיקה', result);
      result;
    } else {
      console.log('User cancelled the prompt.');
    }
  }
  openReciptsForContactDlg() {
    let contactReciptsMdl = new ContactReciptsMdl();
    contactReciptsMdl.contactID = this.id;
    contactReciptsMdl.mergePayments = null;

    //let mdc = new MatDialogConfig<any>();
    //mdc.data = this.id;
    const dialogRef = this.dialog.open(ContactReciptsDlg, {
      data: this.id,
      width: '80%'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.value) {
        let cid = result.value.contactID;
        let paymentsIds = result.value.paymentsIds;
        let mergePayments = result.value.mergePayments;
        this.contactsData.createAndPrintReceiptsForAnyPayments(cid, mergePayments, paymentsIds)
          .subscribe((c: any) => {
            let popupWinindow: any = window.open('', '_blank', 'scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no, onload="window.print()"');
            popupWinindow.document.open();
            popupWinindow.document.write('<html><head><style type="text/css"> tr.payments:nth-child(even){background-color: #f2f2f2} @page { size: A4; margin: 0; } @media print { html, body { width: 210mm; height: 297mm; } .page { margin: 0; border: initial; border-radius: initial; width: initial; min-height: initial; box-shadow: initial; background: initial; page-break-after: always; } } </style></head><body  onload="window.print()"><div>' + (<any>c).value + '</div></body></html>');
            popupWinindow.document.close();
            return true;
            //this.matDialogRef.close();
          });
      }
    });
  }



  createAndrintNewReceiptsForContact(): void {
    this.printNewReceiptsForContact(true);
  }
  public printNewReceiptsForContact(andCreate = false): void {
    this.contactsData.printNewReceiptsForContact(this.id, andCreate)
      .subscribe(
        data => {
          //     if (blob !== '') {
          // tslint:disable-next-line:max-line-length
          let popupWinindow: any = window.open('', '_blank', 'scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
          popupWinindow.document.open();
          // tslint:disable-next-line:max-line-length
          popupWinindow.document.write('<html><head><style type="text/css"> tr.payments:nth-child(even){background-color: #f2f2f2} @page { size: letter; margin: 0; } @media print { html, body { width: 210mm; height: 297mm; } .page { margin: 0; border: initial; border-radius: initial; width: initial; min-height: initial; box-shadow: initial; background: initial; page-break-after: always; } } </style></head><body  onload="window.print()"><div>' + (<any>data).value + '</div></body></html>');
          popupWinindow.document.close();
        }
      )
  }


  selectedCommitmentsRowsChange($event) {
    this.selectedCommitmentsIDs = $event.map(function (e) {
      return e.commitmentID;
    });
  }


  selectedCommitmentsIDs;
  public getContactShortInformation(): void {
    // let doDownload = true;
    const dialogRef = this.dialog.open(ContactReportModelDlg, {
      data: {
        contactID: this.id,
        contactName: `${this.contact.firstName} ${this.contact.lastName}`,
        selectedCommitmentsIDs: this.selectedCommitmentsIDs
      }
    });


    dialogRef.afterClosed().subscribe(result => {
      if (result && result.valid) {
        this.dowloand(result.value);
      }
    });

  }
  dowloand(result: any) {
    this.contactsData.getContactShortInformation(result).subscribe((blob: any) => {
      var blb = new Blob([blob], { type: "application/pdf;charset=utf-8" });
      saveAs(blb, `דוח ${this.contact.perfix} ${this.contact.firstName} ${this.contact.lastName} ${this.contact.suffix}.pdf`);
    });
  }

  public printAllContactInformation(): void {
    let doDownload = true;
    this.contactsData.printAllContactInformation(this.id).subscribe((blob: any) => {
      var blb = new Blob([blob], { type: "application/pdf;charset=utf-8" });
      saveAs(blb, `דוח ${this.contact.perfix} ${this.contact.firstName} ${this.contact.lastName} ${this.contact.suffix}.pdf`);
    });

  }




  public printEnvelopeorContact(): void {
    this.contactsData.printEnvelopeorContact(this.id)
      .subscribe(
        data => {
          // tslint:disable-next-line:max-line-length
          let popupWinindow: any = window.open('', '_blank', 'scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
          popupWinindow.document.open();
          // tslint:disable-next-line:max-line-length
          popupWinindow.document.write('<html><head><style type="text/css"> tr.payments:nth-child(even){background-color: #f2f2f2} @page {size: 110mm 230mm;}@media (max-width: 230mm) {@page { size: 110mm 230mm;}} </style></head><body  onload="window.print()"><style>@page {size: 110mm 230mm;} @media (max-width: 230mm) { @page { size: 110mm 230mm;}} @media print {@page { size: 110mm 230mm;}} </style><div>' + (<any>data).value + '</div></body></html>');
          popupWinindow.document.close();
        }
      )
  };


  ngOnInit() {
    this.activatedRoute.params.forEach((params: Params) => {
      this.id = + params['contactID'];
      this.codeIchud = + params['codeIchud'];
      this.loadContact();
      this.activeTabIndex = sessionStorage.getItem(`${this.pathStr}`) || 0;

    });
  }
  get pathStr() {
    return `${this.perfix}${this.location.path()}`;
  }



  activeTabIndex;
  perfix = "tabs_";
  public itemSelect(event) {
    this.activeTabIndex = 're'
    this.activeTabIndex = event.index;
    sessionStorage.setItem(`${this.pathStr}`, `${this.activeTabIndex}`);
    this.cdref.detectChanges();
  }


}
